var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4 4L20 20M4 4V12M4 4H12","stroke":"#030C1A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }